import Carousel from "react-bootstrap/Carousel";

import ProductCard from "../components/Product/ProductCard";
import Review from "../components/Review/Review.jsx";

import products, { giftProducts } from "../data/product.js";
import reviews from "../data/review.js";
import FavoriteProductCard from "../components/Product/FavoriteProdact.jsx";

import About from "./About.jsx";
import ProductFilter from "../components/Product/ProductFilter.jsx";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function Home() {
  const { language } = useContext(LanguageContext);
  const text = {
    tr: {
      products: "Ürünler",
      favorite: "Favori Ürünler",
      gifts: "Hediyeler",
      reviews: "Müşteri Yorumları",
    },
    en: {
      products: "Products",
      favorite: "Favorite Products",
      gifts: "Gifts",
      reviews: "Customer Reviews",
    },
  };
  return (
    <>
      {/* COURSEL RESIMLERI */}
      <Carousel className="hero-carousel">
        <Carousel.Item>
          <img
            className="hero-img d-block w-100"
            src="/img/LaleKuruyemisMix.png"
            alt="Slide 1"
          />
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="hero-img d-block w-100"
            src="/img/gift.png"
            alt="Slide 2"
          />
        </Carousel.Item>

        <Carousel.Item>
          <img
              className="hero-img d-block w-100"
            src="/img/yenimahsul.png"
            alt="Slide 3"
          />
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="hero-img d-block w-100"
            src="/img/Istanbul.png"
            alt="Slide 4"
          />
        </Carousel.Item>
      </Carousel>

      {/* URUNLER */}
      <div className="product-card-header text-center mt-5">
        <h2>{text[language].products}</h2>
      </div>
      <ProductFilter />

      {/* FAVORİ ÜRÜNLER ILK 4 URUN  */}
      <div className="product-card-header text-center mt-5">
        <h2>{text[language].favorite}</h2>
      </div>
      <div className="container py-4">
        <div className="row g-4">
          {products.slice(1, 5).map((product) => (
            <div key={product.id} className="col-12 col-sm-6 col-md-3 d-flex">
              <FavoriteProductCard product={product} />
            </div>
          ))}
        </div>
      </div>

      {/* GIFT URUNLERI */}
      <div className="product-card-header text-center mt-5">
        <h2>{text[language].gifts}</h2>
      </div>

      <div className="container py-4">
        <div className="row g-4">
          {giftProducts.map((giftProducts) => (
            <div
              key={giftProducts.id}
              className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
            >
              <ProductCard product={giftProducts} />
            </div>
          ))}
        </div>
      </div>

      {/* REVIEWS */}
      {reviews.length > 0 && <Review title={text[language].reviews} />}

      {/* About */}
      <About />
    </>
  );
}
